import { Leaf, ArrowUp } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-forest text-background" data-testid="footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-6">
                        <div className="flex items-center gap-2 mb-6">
                            <Leaf className="w-5 h-5 text-sage" strokeWidth={1.5} />
                            <span className="font-serif text-2xl font-medium tracking-tight">The Zami Concept</span>
                        </div>
                        <p className="text-sm font-light leading-relaxed text-sage/80 max-w-sm">
                            Dependable commercial cleaning for offices, retail and food-service outlets,
                            and industrial facilities — serving multiple states across Nigeria.
                        </p>
                    </div>
                    <div className="md:col-span-3">
                        <p className="text-xs font-bold tracking-[0.2em] uppercase text-sage mb-5">Explore</p>
                        <div className="flex flex-col gap-3">
                            {["services", "standards", "about", "contact"].map((id) => (
                                <button
                                    key={id}
                                    data-testid={`footer-link-${id}`}
                                    onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                                    className="text-left text-sm font-light text-background/80 hover:text-background transition-colors duration-300 capitalize"
                                >
                                    {id === "standards" ? "Our Standards" : id.charAt(0).toUpperCase() + id.slice(1)}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="md:col-span-3">
                        <p className="text-xs font-bold tracking-[0.2em] uppercase text-sage mb-5">Contact</p>
                        <div className="flex flex-col gap-3 text-sm font-light text-background/80">
                            <a data-testid="footer-email-link" href="mailto:info@thezamiconcept.com" className="hover:text-background transition-colors duration-300">
                                info@thezamiconcept.com
                            </a>
                            <a data-testid="footer-phone-link" href="tel:+2348039485843" className="hover:text-background transition-colors duration-300">
                                +234 803 948 5843
                            </a>
                            <span>Wemabod Estate, Ikeja, Lagos</span>
                            <span>Serving Lagos and multiple states across Nigeria</span>
                        </div>
                    </div>
                </div>
                <div className="mt-16 pt-8 border-t border-background/15 flex items-center justify-between">
                    <p className="text-xs font-light text-sage/70">
                        © {new Date().getFullYear()} The Zami Concept. All rights reserved.
                    </p>
                    <button
                        data-testid="footer-back-to-top"
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        aria-label="Back to top"
                        className="w-10 h-10 rounded-full border border-background/25 flex items-center justify-center hover:bg-background hover:text-forest transition-colors duration-300"
                    >
                        <ArrowUp className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </footer>
    );
}
